export function Chip({ active, onClick, children, testId, disabled }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className={`px-3.5 py-2 rounded-full text-sm font-medium border transition-colors ${
        disabled ? "opacity-40 cursor-not-allowed border-white/10 text-[#64748B]" :
        active
          ? "bg-[#FF334B] border-[#FF334B] text-white"
          : "border-white/12 text-[#94A3B8] hover:border-[#FF334B]/50 hover:text-white"
      }`}
    >
      {children}
    </button>
  );
}
